import { render, staticRenderFns } from "./dynamic-addLinkAlert.vue?vue&type=template&id=54161994&scoped=true&"
import script from "./dynamic-addLinkAlert.vue?vue&type=script&lang=js&"
export * from "./dynamic-addLinkAlert.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-addLinkAlert.vue?vue&type=style&index=0&id=54161994&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54161994",
  null
  
)

export default component.exports